import { engine } from '../audio/engine.ts';
import { startRecording, stopRecording } from '../audio/recorder.ts';
import { useStudio } from '../state/store.ts';
import { useEdit } from '../state/edit.ts';
import { fmtBars, fmtTime, toast, useFrame } from './ui.tsx';

export async function togglePlay() {
  const st = useStudio.getState();
  if (st.transport.recording) return void (await stopRecording());
  if (st.transport.playing) return engine.stop();
  // Wie in Pro Tools: Mit einer Auswahl spielt die Auswahl (im Loop wiederholt), sonst ab der Einfügemarke
  const r = useEdit.getState().range;
  if (r && r.end - r.start > 0.01) {
    if (st.project.loop.enabled) { if (Math.abs(st.project.loop.start - r.start) > 1e-3 || Math.abs(st.project.loop.end - r.end) > 1e-3) st.commit('Loop auf Auswahl', (p) => { p.loop.start = r.start; p.loop.end = r.end; }); return void (await engine.play(r.start)); }
    return void (await engine.play(r.start, r.end));
  }
  await engine.play(r ? r.start : undefined);
}
export async function toggleRecord() {
  const st = useStudio.getState();
  if (st.transport.recording) return void (await stopRecording());
  try { await startRecording(); } catch (e) { toast((e as Error).message); }
}

export function Transport() {
  const t = useStudio((s) => s.transport);
  const p = useStudio((s) => s.project);
  const set = useStudio((s) => s.setTransport);
  const commit = useStudio((s) => s.commit);
  const hist = useStudio((s) => s.history);
  const pos = useFrame(() => engine.position);
  return (
    <div className="transport">
      <div className="row">
        <button className="tbtn" title="Zum Anfang (Enter)" onClick={() => engine.locate(0)}>⏮</button>
        <button className={`tbtn ${t.playing && !t.recording ? 'on' : ''}`} title="Wiedergabe (Leertaste)" onClick={() => void togglePlay()}>{t.playing ? '■' : '▶'}</button>
        <button className={`tbtn rec ${t.recording ? 'on' : ''}`} title="Aufnahme (R)" onClick={() => void toggleRecord()}>●</button>
        <button className={`tbtn ${p.loop.enabled ? 'on' : ''}`} title="Loop (L)" onClick={() => commit('Loop', (x) => { x.loop.enabled = !x.loop.enabled; })}>⟲</button>
        <button className={`tbtn ${t.metronome ? 'on' : ''}`} title="Klick (K)" onClick={() => set({ metronome: !t.metronome })}>♩</button>
      </div>
      <div className="clock">{fmtBars(p, pos)}</div>
      <div className="mono t2" style={{ fontSize: 12 }}>{fmtTime(pos)}</div>
      <div className="meta">
        <span>BPM</span>
        <input type="number" value={p.bpm} min={40} max={240} onChange={(e) => commit('Tempo', (x) => { x.bpm = Number(e.target.value) || x.bpm; }, { merge: true })} />
        <span>Tonart</span>
        <input style={{ width: 90 }} value={p.key} onChange={(e) => commit('Tonart', (x) => { x.key = e.target.value; }, { merge: true })} />
        <label className="row" style={{ gap: 4 }}><input type="checkbox" style={{ width: 'auto' }} checked={t.countIn} onChange={(e) => set({ countIn: e.target.checked })} />Vorzähler</label>
      </div>
      <div className="row" style={{ marginLeft: 'auto' }}>
        <button className="btn small" disabled={!hist.past.length} onClick={() => useStudio.getState().undo()}>↶ Rückgängig</button>
        <button className="btn small" disabled={!hist.future.length} onClick={() => useStudio.getState().redo()}>↷</button>
      </div>
    </div>
  );
}
